define(function(require, exports, module) {
    'use strict';

    const CommonLookupView = require('common/addressLookupSwiss/lookupControls/commonLookupView');
    const HouseNumberProvider = require('common/addressLookupSwiss/sourceProviders/houseNumberProvider');

    module.exports = CommonLookupView.extend({
        controlType: 'houseNumber',

        options: {
            ...CommonLookupView.prototype.options,
            minLength: 1
        },

        SourceProvider: HouseNumberProvider,

        update: function(model) {
            const changed = model.changed;
            const controlType = model.get('controlType');

            if (changed.selectedItem) {
                const prevSearchResult = this.model.get('prevSearchResult');

                this.model.set({
                    prevSearchResult: { ...prevSearchResult, ...changed.selectedItem }
                });

                if (controlType === 'streetName') {
                    this.model.set({
                        hidden: false,
                        showInnerFields: false
                    });

                    this.$el.find('.fn-lookup-input-text')[0].focus();
                }
            }
        },

        /**
         * @override
         * @returns {string}
         */
        getValidationError: function() {
            return 'playtech.mobile.registration.addressLookupSwiss.houseNumber.validation';
        }
    });

});
